import { Box, Tabs, Tab, Paper } from "@mui/material";
import { useState } from "react";
import AdminReviewForm from "./AdminReviewForm";
import HistoricalAppraisalChart from "../ProjectRatings/HistoricAppraisalChart";
import ReviewDownloadAdmin from "../Review/ReviewDownloadAdmin";

const AdminAppraisal = () => {
  const [tabIndex, setTabIndex] = useState(0);

  // Map each tab to a component
  const tabComponents = [
    <AdminReviewForm />,  // Current Appraisals
    <HistoricalAppraisalChart />,  // Past Appraisals
    <ReviewDownloadAdmin />,  // Download
  ];

  return (
    <Box sx={{ width: "100%", mt: 8 }}>
  {/* Centered Tabs */}
  <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
    <Tabs
      value={tabIndex}
      onChange={(event, newValue) => setTabIndex(newValue)}
      aria-label="Admin Appraisal Tabs"
      textColor="inherit"
      indicatorColor="primary"
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        minHeight: 0,
        maxWidth: "100%",  // Allow full width
        "& .MuiTabs-flexContainer": {
          justifyContent: "center",  // Center the tabs
        },
        "& .MuiTab-root": {
          minHeight: 0,
          padding: "10px 20px",
        },
      }}
      centered={false}  // Disable default centering for better control
    >
      <Tab label="Current Appraisals" />
      <Tab label="Past Appraisals" />
      <Tab label="Download" />
    </Tabs>
  </Box>

  {/* Main Content */}
  <Box sx={{ p: 3 }}>{tabComponents[tabIndex]}</Box>
</Box>

  );
};

export default AdminAppraisal;
